import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {CmsConfig, I18nModule, provideConfig, provideDefaultConfig} from '@spartacus/core';
import { UigShopViewComponent } from './uig-shop-view.component';
import { LoginGuard } from '@spartacus/storefront';
import { UigLoginGuard } from 'src/app/guards/uig-login.guard';

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
  ],
  declarations: [UigShopViewComponent],
  providers: [
    {
      provide: LoginGuard,
      useClass: UigLoginGuard
    },
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ShopViewComponent: {
          component: UigShopViewComponent,
        },
      },
    }),
  ],
  exports: [UigShopViewComponent]
})
export class UigShopViewModule { }
